import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { useVolumeHover } from "~/feature/chart/providers/VolumeHoverProvider";
import { getPointLeftPercent } from "~/feature/chart/utils";

import { buildChartTooltip } from "./buildChartTooltip";
import { FLIP_LEFT_PERCENT } from "./constants";

export const useChartTooltip = () => {
  const { markets, selections, chanceHistory, timeline, viewMode } =
    useCoreChart();
  const { hoveredIndex } = useVolumeHover();
  const theme = useTheme();
  const consensusColor = theme.palette.gold.dark;

  const hoveredTimestamp =
    hoveredIndex === null ? null : (timeline[hoveredIndex] ?? null);

  const boxes = useMemo(
    () =>
      buildChartTooltip({
        markets,
        selections,
        chanceHistory,
        hoveredTimestamp,
        viewMode,
        consensusColor,
      }),
    [
      chanceHistory,
      consensusColor,
      hoveredTimestamp,
      markets,
      selections,
      viewMode,
    ]
  );

  const leftPercent =
    hoveredIndex === null
      ? 0
      : getPointLeftPercent(hoveredIndex, timeline.length);

  return {
    boxes,
    leftPercent,
    isFlipped: leftPercent > FLIP_LEFT_PERCENT,
  };
};
